import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import React, { useState } from "react";
import { OrderDialog } from "../trading/OrderDialog";
import { InvestmentGoalsDialog } from "../trading/InvestmentGoalsDialog";
import { useToast } from "@/components/ui/use-toast";
import { useNavigate } from "react-router-dom";
import { createNavItems } from "@/constants/navigation";

interface DarkSidebarProps {
  className?: string;
}

export const DarkSidebar = ({ className }: DarkSidebarProps) => {
  const [showOrderDialog, setShowOrderDialog] = useState(false);
  const [showGoalsDialog, setShowGoalsDialog] = useState(false);
  const { toast } = useToast();
  const navigate = useNavigate();

  const handleOrderSubmit = (data: {
    name?: string;
    symbol?: string;
    direction?: string;
    engine?: string;
    duration?: string;
  }) => {
    // Generate a strategy name if none provided, with safe handling of undefined values
    const strategyName = data.name || 
      `${(data.direction || 'BUY').toUpperCase()} ${data.symbol || 'UNKNOWN'} ${data.duration || 'DAY'}`;
    
    // Here you would typically handle the order submission
    // For now, we'll just show a toast notification
    toast({
      title: "Order Placed",
      description: `${strategyName} strategy has been created.`,
    });
    
    setShowOrderDialog(false);
  };

  const navItems = createNavItems(navigate, setShowOrderDialog);

  return (
    <div
      className={cn(
        "group/sidebar h-screen relative bg-slate-800/30 backdrop-blur-lg border-r border-r-slate-700/30 shadow-lg transition-all duration-300 ease-in-out w-[70px]",
        className
      )}
    >

      <div className="flex flex-col gap-2 p-4">
        {navItems.map((item, index) => (
          <div key={index} className="space-y-1">
            <Button
              variant="ghost"
              onClick={item.onClick}
              className="group flex items-center p-2 w-12 bg-slate-700/60 hover:bg-slate-600/70 text-slate-300 hover:text-slate-100 border border-slate-600/50 hover:border-slate-500/70 shadow-sm backdrop-blur-sm transition-all duration-200 hover:w-48 overflow-hidden"
            >
              <item.icon className="h-5 w-5 flex-shrink-0" />
              <span className="ml-2 text-sm font-medium overflow-hidden whitespace-nowrap transition-all duration-200 max-w-0 opacity-0 group-hover:max-w-[10rem] group-hover:opacity-100">
                {item.title}
              </span>
            </Button>
          </div>
        ))}
      </div>

      <OrderDialog
        open={showOrderDialog}
        onOpenChange={setShowOrderDialog}
        onSubmit={handleOrderSubmit}
      />

      <InvestmentGoalsDialog
        open={showGoalsDialog}
        onOpenChange={setShowGoalsDialog}
      />
    </div>
  );
}; 